<template>
<div class="chapter">
<div class="inner_page">
<section aria-label="Dedication">
<p class="ded" id="ded"><span aria-label=" Page xii. " epub:type="pagebreak" id="page_xii" role="doc-pagebreak"><i>To life,<br/>in its full flourishing</i><span aria-label=" Page xiii. " epub:type="pagebreak" id="page_xiii" role="doc-pagebreak"></span></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?179068b8